/**
 * @author      yewon@zumper.com (Yewon Lee)
 * @copyright   Copyright (c) 2018, Zumper
 * @description savedSearchesReducer
 */

import Searches, { SavedSearch } from '@zcode/nr/es/shared/bizos/searches'
import { alwaysReducer } from '@zcode/reducers'
import { combineActions, handleActions } from 'redux-actions'
import {
  GET_SAVED_SEARCHES_SUCCESS,
  HIDE,
  RESET_SAVED_SEARCHES_VIEW,
  SUCCESS_REMOVING,
  SUCCESS_UPDATING,
  UPDATE_SAVED_SEARCHES,
} from '../constants/index'

const savedSearchesReducer = handleActions(
  {
    [combineActions(UPDATE_SAVED_SEARCHES, GET_SAVED_SEARCHES_SUCCESS)]: (state, action) => {
      const { payload } = action
      if (payload.savedSearches) {
        return Searches.fromJS(payload.savedSearches)
      }
      return state
    },
    [SUCCESS_UPDATING]: (state, action) => {
      const { payload } = action
      const { savedSearch } = payload
      if (savedSearch) {
        // savedSearches at this point is not an immutable object
        const imSavedSearch = SavedSearch.fromJS(savedSearch)
        const idx = state.findIndex(({ searchId }) => {
          return searchId === imSavedSearch.searchId
        })
        if (idx > -1) {
          const newState = [...state]
          newState[idx] = imSavedSearch
          return newState
        }
      }
      return state
    },
    [SUCCESS_REMOVING]: (state, action) => {
      const { payload } = action
      const { searchId } = payload
      if (searchId) {
        const idx = state.findIndex((search) => search.searchId === searchId)

        if (idx > -1) {
          const newState = [...state]
          newState.splice(idx, 1)
          return newState
        }
      }
      return state
    },
    [combineActions(HIDE, RESET_SAVED_SEARCHES_VIEW)]: alwaysReducer([]),
  },
  []
)

export default savedSearchesReducer
